// бэкенд preferences-personal-api отключили, см. NB-6873 - выставялем флаг чтобы не показывать кнопки
// лайков и прочей персонализации, т.к. выпиливать по нормальному сложно и дорого
export const usePersonalPreferences = false;
